// Lib
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// Selectors
import { areCustomTemplatesInitialised, isAppInitCompleted } from '../../../app/initialisation/initialisationSelector';

// Actions
import { fetchCurrentUserInitialCustomTemplates } from '../../../user/currentUserActions';

/**
 * Loads the custom templates after the app is initialised and the template popup shows up,
 * if the custom templates haven't been loaded already.
 */
const CustomTemplateLoader = (): null => {
    const customTemplatesInitialised = useSelector(areCustomTemplatesInitialised);
    const appInitCompleted = useSelector(isAppInitCompleted);

    const dispatch = useDispatch();
    const dispatchFetchCurrentUserInitialCustomTemplates = () => dispatch(fetchCurrentUserInitialCustomTemplates());

    useEffect(() => {
        if (customTemplatesInitialised) return;

        dispatchFetchCurrentUserInitialCustomTemplates();
    }, [appInitCompleted]);

    return null;
};

export default CustomTemplateLoader;
